export default "__VITE_ASSET__46bea5b8__"